import useTouchAction from 'hooks/common/useTouchAction';
import { useState } from 'react';

/** 이 거리를 넘게 당겨야 로티가 나온다. */
const SHOW_AT = 40;

/** 놓았을 때 새로 받는 거리. 벌어진 높이가 최대치에 닿는 지점이다. */
const TRIGGER_AT = 120;

const HEIGHT_DIVISOR = 1.2;
const MAX_HEIGHT = 100;

/** 목록 로딩 스피너와 같은 크기로 맞춘다. */
const ICON_SIZE = 32;

interface PullToRefreshProps {
  containerRef: React.RefObject<HTMLDivElement>;
  refreshing: boolean;
  onRefresh: () => void;
}

const PullToRefresh: React.FC<PullToRefreshProps> = ({ containerRef, refreshing, onRefresh }) => {
  const [height, setHeight] = useState(0);

  useTouchAction({
    containerRef,
    onTouchAction: (distance, touchEnd) => {
      if (refreshing) return;
      if (touchEnd) {
        if (distance >= TRIGGER_AT) onRefresh();
        setHeight(0);
        return;
      }
      setHeight(distance > SHOW_AT ? Math.min(distance / HEIGHT_DIVISOR, MAX_HEIGHT) : 0);
    },
  });

  const open = refreshing || height > 0;

  return (
    <div
      className="flex w-full flex-shrink-0 items-center justify-center overflow-hidden transition-[height] duration-100 ease-in-out"
      style={{ height: refreshing ? MAX_HEIGHT / 2 : height }}
    >
      {/* 로티 원본이 400×400 이라 크기를 안 박으면 그대로 커진다. lottie-player 가 :host 로 100% 를
          걸어 두기도 해서, 클래스 대신 인라인으로 못 박는다. */}
      {open && (
        <lottie-player
          src="/imgweb/lottie/scene_upload.json"
          background="transparent"
          speed="1"
          autoplay
          loop
          style={{ width: `${ICON_SIZE}px`, height: `${ICON_SIZE}px` }}
        />
      )}
    </div>
  );
};

export default PullToRefresh;
